import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useItemPriceState = (itemNo, enabled) => {
  return useQuery({
    queryKey: ["itemPriceState", itemNo],
    enabled: enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes fresh
    cacheTime: 10 * 60 * 1000, // keep in cache for reuse
    queryFn: async () =>
      callApi({
        path: "getitemprice",
        command: "",
        data: JSON.stringify({
          data: { filter: { itemNo: itemNo } },
        }),
      }),
  });
};
